import { useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Link } from 'react-router-dom';
import Prism from 'prismjs';

interface MarkdownViewProps {
  markdown: string;
  testId?: string;
}

/**
 * Renders untrusted markdown (Claude search responses, etc.) client-side. Mirrors the server feature
 * set: GFM, autolinks, Prism syntax highlighting after mount. In-app `/wiki/...` and `/raw/...`
 * anchors go through react-router so navigation stays SPA-style.
 */
export default function MarkdownView({ markdown, testId }: MarkdownViewProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) Prism.highlightAllUnder(ref.current);
  }, [markdown]);

  return (
    <div ref={ref} className="prose" data-testid={testId}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a({ href, children, ...rest }) {
            if (href && (href.startsWith('/wiki/') || href.startsWith('/raw/'))) {
              return (
                <Link to={href} {...rest}>
                  {children}
                </Link>
              );
            }
            return (
              <a href={href} {...rest}>
                {children}
              </a>
            );
          },
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
}
